"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextComponent = void 0;
var React = require("react");
exports.TextComponent = function (props) {
    var handleOrderedListOffset = function (elem) {
        if (elem) {
            var maybeOrderedList = elem.querySelector('.text-component > ol');
            if (maybeOrderedList) {
                var listNumberingStart = props.listOffset + 1;
                maybeOrderedList.setAttribute('start', listNumberingStart.toString());
            }
        }
    };
    var handleVRIcons = function (elem) {
        if (elem) {
            Array.from(elem.querySelectorAll('img')).forEach(function (icon) { return icon.setAttribute('aria-hidden', 'true'); });
        }
    };
    var orderedListOffsetHandler = function (elem) {
        handleOrderedListOffset(elem);
        handleVRIcons(elem);
    };
    var html = { __html: props.value.html };
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return (React.createElement("div", { className: "component text-component" + (isSafari ? ' is-safari' : ''), "data-component-type": 'text', ref: orderedListOffsetHandler, dangerouslySetInnerHTML: html }));
};
//# sourceMappingURL=text-component.comp.js.map